import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from '../Collapse';

export default class Filter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    collapse: PropTypes.bool,
    hasSelected: PropTypes.bool,
    expanded: PropTypes.bool,
    onChange: PropTypes.func,
    onLocalReset: PropTypes.func,
    onGlobalReset: PropTypes.func,
    noSpacing: PropTypes.bool
  }

  static defaultProps = {
    collapse: true,
    hasSelected: false,
    expanded: true,
    onChange() {},
    onLocalReset() {},
    onGlobalReset() {},
    noSpacing: false
  }

  componentDidMount() {
    $(document).on(`${this.props.id === 'sort' ? 'sorter' : this.props.id}-reset`, () => {
      if (this.props.hasSelected || this.props.type === "Tag") {
        this.props.onGlobalReset();
      }
    });
  }

  componentWillUnmount() {
    $(document).off(`${this.props.id === 'sort' ? 'sorter' : this.props.id}-reset`);
  }

  handleLocalResetClick = () => {
    this.props.onLocalReset();
  }

  render() {
    return (
      <div className={this.props.noSpacing ? '': 'u-p-2 lg:u-p-0'}>
        { this.props.collapse ? (
          <Collapse
            id={this.props.id}
            label={this.props.title}
            key={this.props.id}
            actionTriggerLabel={this.props.hasSelected ? 'Reset' : null}
            onActionTriggerClick={this.handleLocalResetClick}
            expanded={this.props.expanded}
            expandedChange={(filter) => this.props.onChange('expanded', filter)}
          >
            {this.props.children}
          </Collapse>
        ) : this.props.children }
      </div>
    );
  }
}
